<div class="init-screen">
    <h2>Initializing Application...</h2>
    <div class="loader"></div>
</div>
